import Loader from "~/app/components/Loader";

import loadable from "~/app/utils/loadable";

export default loadable(() => import("./LoggedIn"), {
  fallback: <Loader size="large" type="absolute" />,
});
